import { StoreEnhancer, applyMiddleware, compose } from 'redux';

import { RootState } from 'shared/types/RootState';

export function getStoreEnhancers(debugEnabled: boolean): StoreEnhancer<RootState> {
  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  return composeEnhancers(applyMiddleware()) as StoreEnhancer<RootState>;
}
